import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const delete_file = (id) => {
  return api.post(
    `${ApiEndpointConstants.DELETEMODEL}`,
    {},
    { params: { id } }
  );
};
